declare global {
  interface Window { _paq?: unknown[][]; }
}

let lastTrackedUrl = '';

function currentUrl(): string {
  const path = window.location.pathname || '/';
  const hash = window.location.hash || '';
  const search = window.location.search || '';
  return `${path}${search}${hash}`;
}

export function trackMatomoSpaPageView(): void {
  if (typeof window === 'undefined' || !window._paq) return;
  const url = currentUrl();
  if (!url || url === lastTrackedUrl) return;
  lastTrackedUrl = url;
  window._paq.push(['setCustomUrl', url]);
  window._paq.push(['setDocumentTitle', document.title || 'RCD² Engine']);
  window._paq.push(['trackPageView']);
}

export function installMatomoSpaTracking(): void {
  if (typeof window === 'undefined') return;
  const onRouteChange = () => window.setTimeout(trackMatomoSpaPageView, 0);
  window.addEventListener('hashchange', onRouteChange);
  window.addEventListener('popstate', onRouteChange);
  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;
  window.history.pushState = function patchedPushState(...args) {
    const result = originalPushState.apply(this, args);
    onRouteChange();
    return result;
  };
  window.history.replaceState = function patchedReplaceState(...args) {
    const result = originalReplaceState.apply(this, args);
    onRouteChange();
    return result;
  };
}